import { logger } from '@belong/logging/logger';
import { ISectionPromoBanner } from '@belong/types';
import SectionPromoBanner from './sectionPromoBanner';

const SectionBannerView = (props: ISectionPromoBanner) => {
  if (props.bannerType === 'promo') {
    return <SectionPromoBanner {...props} />;
  }

  if (props.bannerType === 'primary') {
    logger.error(`SectionBannerView does not support 'primary' bannerType yet`);
  }

  if (props.bannerType === 'secondary') {
    logger.error(`SectionBannerView does not support 'secondary' bannerType yet'`);
  }

  logger.error(`SectionBannerView does not support bannerType '${props.bannerType}'`);

  return <></>;
};

export default SectionBannerView;
